import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { colorDanger } from '../../material-ui-theme';

const useStyles = makeStyles((theme) => ({
  errorText: {
    fontSize: '0.9rem',
    fontWeight: 500,
    color: colorDanger.main,
    marginTop: theme.spacing(2),
  },
}));

function ErrorText({
  error = null,
  helperText = 'Error',
  noMargin = false,
  centerAlign = false,
  className = '',
}) {
  const classes = useStyles();

  return (
    <>
      {error ? (
        <div
          className={`${classes.errorText} ${className}`}
          style={{
            marginTop: noMargin ? 0 : null,
            textAlign: centerAlign ? 'center' : null,
          }}
        >
          {helperText}
        </div>
      ) : null}{' '}
    </>
  );
}

export default ErrorText;
